import adminConfig from "./adminConfig";
import wwwConfig from "./wwwConfig";
import Layout from "../pages/Layout";
import store from "../store";
const routes = [
  {
    path: "/",
    component: Layout,
    beforeEnter(to, from, next) {
      if (store.state.system.isFetched) {
        next();
        return;
      }
      store.dispatch("system/fetchSystem").then(() => {
        next();
      });
    },
    children: [...adminConfig, ...wwwConfig]
  }
];

export default routes;
